import { lazy, Suspense } from 'react';
import { Header } from '@/components/layout/Header';
import { Hero } from '@/components/hero/Hero';
import { Seo } from '@/components/Seo';

// Above-the-fold loads eagerly. Everything below is split into its own chunk
// so the initial JS payload stays small (PageSpeed "Reduce unused JavaScript").
const AudienceTabs = lazy(() => import('@/components/audience/AudienceTabs').then(m => ({ default: m.AudienceTabs })));
const ServicesGrid = lazy(() => import('@/components/services/ServicesGrid').then(m => ({ default: m.ServicesGrid })));
const ProcessTimeline = lazy(() => import('@/components/process/ProcessTimeline').then(m => ({ default: m.ProcessTimeline })));
const ValueProposition = lazy(() => import('@/components/value/ValueProposition').then(m => ({ default: m.ValueProposition })));
const WhySection = lazy(() => import('@/components/WhySection').then(m => ({ default: m.WhySection })));
const FAQSection = lazy(() => import('@/components/faq/FAQSection').then(m => ({ default: m.FAQSection })));
const Contact = lazy(() => import('@/components/Contact').then(m => ({ default: m.Contact })));
const Footer = lazy(() => import('@/components/Footer').then(m => ({ default: m.Footer })));

const SectionFallback = () => <div style={{ minHeight: '50vh' }} aria-hidden="true" />;

const Index = () => {
  return (
    <div className="min-h-screen">
      <Seo
        title="Yaw CTV | Your Premier Programmatic Partner"
        description="SDVOSB & MBO certified agency for government and business advertising — media buying, OTT/CTV, programmatic, geo-targeted, and social campaigns. Orlando, FL; serving nationwide."
        path="/"
      />
      <Header />
      <main id="main-content">
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <AudienceTabs />
          <ServicesGrid />
          <ProcessTimeline />
          <ValueProposition />
          <WhySection />
          <FAQSection />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
